import { createContext, useContext, ReactNode, useState, useMemo } from 'react';

interface ContractContextType {
  showContractModal: boolean;
  setShowContractModal: (show: boolean) => void;
}

const ContractContext = createContext<ContractContextType | undefined>(undefined);

export const ContractProvider = ({ children }: { children: ReactNode }) => {
  const [showContractModal, setShowContractModal] = useState(false);

  const value = useMemo(() => ({ showContractModal, setShowContractModal }), [showContractModal]);

  return <ContractContext.Provider value={value}>{children}</ContractContext.Provider>;
};

export const useContract = () => {
  const context = useContext(ContractContext);
  if (context === undefined) {
    // log error only for console and senetry in case of undefine and context issue
    throw new Error('useContract must be used within a ContractProvider');
  }
  return context;
};
